<ion-app class="scanner-hide">
  <ion-content>
    <ion-refresher disabled="false" slot="fixed" (ionRefresh)="refreshData($event)">
      <ion-refresher-content refreshingSpinner="circular"></ion-refresher-content>
    </ion-refresher>
    
    <ion-router-outlet></ion-router-outlet>
  </ion-content>
</ion-app>
